import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import PropTypes from "prop-types";
import { get, filter } from "lodash";

import { fetchGet } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";

import CloseIcon from "../../Common/CloseIcon";
import ProfileSurvey from "../../Profiles/ProfileSurvey/ProfileSurvey";

import { updateLiveEvents } from "../../../actions/siteEntranceExit/liveEvents";

import { LANGUAGES } from "../../../constants/common";
import { walkInOut } from "../../../constants/reducers";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";
import { getAttributeValue } from "../../../utils/profile";

const styles = {
  buttonIcon: {
    boxShadow: `0px 1px 2px 0px ${colors.black24}, 0px 1px 3px 0px ${colors.black12}`,
    padding: "0px !important",
    minWidth: "0px",
    "& img": {
      width: "32px",
    },
  },
  closeIcon: {
    display: "flex",
    justifyContent: "flex-end",
  },
  dialogPaper: {
    minWidth: "1300px",
    maxHeight: "900px",
  },
};

const Verification = (props) => {
  const {
    classes,
    open,
    onOpen,
    onClose,
    section,
    zoneId,
    sessionId,
    verificationEventGroup,
    language,
    dispatch,
  } = props;
  const [surveys, setSurveys] = React.useState();

  React.useEffect(() => {
    getSurveys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, verificationEventGroup]);

  const getSurveys = async () => {
    let preSurvey, lastSurvey, referenceSurvey;
    if (verificationEventGroup) {
      preSurvey = get(
        filter(get(verificationEventGroup, ["events"]), (e) =>
          [91].includes(get(e, ["type", "id"]))
        ),
        [0]
      );
      lastSurvey = get(
        filter(get(verificationEventGroup, ["events"]), (e) =>
          [81].includes(get(e, ["type", "id"]))
        ),
        [0]
      );
      if (get(preSurvey, ["reference_event_id"])) {
        referenceSurvey = await fetchGet(
          `events/${get(preSurvey, ["reference_event_id"])}`
        );
      }
    }
    setSurveys({
      preSurvey,
      lastSurvey,
      referenceSurvey,
    });
  };

  const refreshSurvey = () => {
    if (section === walkInOut) {
      let events = get(props, [
        "siteEntranceExit",
        section,
        "liveEvents",
        zoneId,
        "events",
      ]);

      // Remove dacId to force refresh
      events = update(events, {
        [sessionId]: { $unset: ["dacId"] },
      });
      dispatch(updateLiveEvents(section, zoneId, events));
    }
  };

  const getVerificationIcon = () => {
    let attr151;
    if (get(surveys, ["preSurvey", "attributes"])) {
      if (
        getAttributeValue(get(surveys, ["preSurvey"]), 162) === true &&
        getAttributeValue(get(surveys, ["preSurvey"]), 163) === false
      ) {
        attr151 = get(surveys, ["referenceSurvey", "attributes"]);
      } else {
        attr151 = get(surveys, ["lastSurvey", "attributes"]);
      }
    } else {
      attr151 = get(surveys, ["lastSurvey", "attributes"]);
    }

    if (attr151) {
      attr151 = attr151.filter((attr) => attr.id === 151)[0];
      attr151 = get(attr151, ["value"]);
      if (attr151) {
        attr151 = JSON.parse(attr151);
        if (
          get(attr151, ["survey_instructions", "completed"]) &&
          get(attr151, ["survey_state", "yes"]) === 0 &&
          get(attr151, ["survey_state", "other"]) === 0
        ) {
          return images.verificationGreen;
        } else if (get(attr151, ["survey_state", "yes"]) > 0) {
          return images.verificationRed;
        } else {
          return images.verificationOrange;
        }
        // if (get(attr151, ["survey_instructions", "id"]) === 0) {
        //   return images.verificationGreen;
        // }
        // if (get(attr151, ["survey_instructions", "id"]) === 1) {
        //   return images.verificationGreen;
        // }
        // if (get(attr151, ["survey_instructions", "id"]) === 2) {
        //   return images.verificationRed;
        // }
        // if (get(attr151, ["survey_instructions", "id"]) === 3) {
        //   return images.verificationOrange;
        // }
      }
    }
    return images.verificationBlue;
  };

  return (
    <>
      <Button onClick={onOpen} className={classes.buttonIcon}>
        <img
          src={getVerificationIcon()}
          style={{ display: "block" }}
          alt="verification"
        />
      </Button>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ height: "100%", padding: "24px" }}
        >
          <Grid item style={{ marginBottom: "20px" }}>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid
                item
                xs
                className="dialogTitle flexCenter"
                style={{ justifyContent: "center" }}
              >
                <span>{I18n.get("site_profile")}:</span>
                <img
                  src={images.humanIconBlack}
                  alt="human_icon"
                  style={{ margin: "-3px 5px 0px" }}
                />
                <span>{get(props, ["profile", "name"])}</span>
              </Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={onClose} />
              </Grid>
            </Grid>
          </Grid>
          <ProfileSurvey
            surveys={surveys}
            profileId={get(verificationEventGroup, ["profile", "id"])}
            language={language}
            contentMaxHeight="none"
            dialog={true}
            eventGroupId={get(verificationEventGroup, ["id"])}
            onlyEdit={{
              onClose: refreshSurvey,
            }}
          />
        </Grid>
      </Dialog>
    </>
  );
};

Verification.propTypes = {
  verificationEventGroup: PropTypes.object,
  language: PropTypes.oneOf(LANGUAGES),
};

const mapStateToProps = (state) => {
  return {
    siteEntranceExit: state.siteEntranceExit,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(Verification));
